<div class="mx-auto md:w-2/3 w-full">
  <h1 class="font-bold text-4xl">Editing person</h1>

  <%= render "form", person: @person %>

  <div class="mx-auto flex">
    <input type="submit" class="rounded-lg py-3 px-5 bg-blue-600 text-white inline-block font-medium cursor-pointer" form="person-form" value="Update Person">

    <% unless @locked %>
    <%= button_to "Remove this person", person_path(@person), method: :delete, class: "btn-grey my-0", form: { data: { turbo_confirm: "Are you sure?" } } %>
    <% end %>

    <% if @person.studio %>
    <%= link_to "Back to Studio", @person.studio, class: "btn-green my-0" %>
    <% else %>
    <%= link_to "Back to Event Staff", studio_path(0), class: "btn-green my-0" %>
    <% end %>
  </div>
</div>
